import React, { useState } from 'react';
import './priceCard.scss'
import info from '@assets/images/icon/ic_inforcircle_nor_24.svg';

type Type = 'now' | 'after' | 'complete'
type Props = {
    type: Type;
    title: string;
    price?: number | null;
    noti? :string;
    date?:string
}
const PriceCard = ({type, title, price=null, noti=null, date='예식당일'}:Props) => {
    const typeString = type.replaceAll('now','지금결제').replaceAll('after','추후').replaceAll('complete','완료')
    const [showTooltip, setShowTooltip] = useState(false);

    const handleMouseEnter = () => setShowTooltip(true);
    const handleMouseLeave = () => setShowTooltip(false);
    const handleTouch = () => setShowTooltip(!showTooltip);
    const closeTooltip = () => setShowTooltip(false);

    return (
        <div className={`price-card-wrap ${type}`}>
            <p className='card-header'>{typeString}</p>
            <div className='card-content'>
                <p>
                    {title}
                    {noti && 
                    <span
                        className="tooltip-wrapper"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        onTouchStart={handleTouch}
                    >
                    <img className="icon" src={info} alt="" />
                    {showTooltip && (
                        <div className="tooltip">
                        <div className="tooltip-header">
                            <strong>{title}</strong>
                            <button className="close-btn" onClick={closeTooltip}>
                            &times;
                            </button>
                        </div>
                        <p>{noti}</p>
                        </div>
                    )}
                    </span>
                }
                </p>
                <p className='bold'>{price ? price.toLocaleString()+'원' : '미정'}</p>
                <p>{date}</p>
            </div>
            
        </div>
    );
};

export default PriceCard;